import { render, staticRenderFns } from "./DeleteExerciseDlg.vue?vue&type=template&id=c144d064&scoped=true&"
import script from "./DeleteExerciseDlg.vue?vue&type=script&lang=ts&"
export * from "./DeleteExerciseDlg.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteExerciseDlg.vue?vue&type=style&index=0&id=c144d064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c144d064",
  null
  
)

export default component.exports